function isObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function arrayDiff(initial, final, {
  comparator = (a, b) => a.id === b.id,
  includeModified = true
}) {
  const added = final.filter((a) => !initial.some((b) => comparator(a, b)));
  const removed = initial.filter((b) => !final.some((a) => comparator(a, b)));
  if (includeModified === false)
    return { added, removed };
  const modified = initial.reduce((acc, a, aIndex) => {
    const b = final.find((b2) => comparator(a, b2));
    if (!b)
      return acc;
    const bIndex = final.indexOf(b);
    const reordered = bIndex !== aIndex;
    const updated = JSON.stringify(a) !== JSON.stringify(b);
    if (!reordered && !updated)
      return acc;
    acc.push({
      initial: a,
      final: b,
      initialIndex: aIndex,
      finalIndex: bIndex,
      reordered,
      updated
    });
    return acc;
  }, []);
  return {
    added,
    removed,
    modified
  };
}

export { arrayDiff as a, isObject as i };
//# sourceMappingURL=arrayDiff-DwhGsjcf.js.map
